import createReducer from 'shared/utils/createReducer';
import { LOGOUT } from 'modules/auth/actions/logout';

import { STOP_CONSULTATION, STOP_CONSULTATION_LOCAL, HIDE_FINISHED_CONSULTATION } from 'modules/conference/actions/stopConsultation';
import { START_CONSULTATION_TIMER, STOP_CONSULTATION_TIMER } from '../epics/startConsultationTimer';

const defaultState = {
  consultationStartedTime: undefined,
  channel: undefined,
};

export default createReducer(defaultState, {
  [START_CONSULTATION_TIMER]: (state, { payload: { channel } }) => ({
    ...state,
    channel,
    consultationStartedTime: Date.now(),
  }),

  [STOP_CONSULTATION_TIMER]: () => defaultState,
  [STOP_CONSULTATION.pending]: () => defaultState,
  [STOP_CONSULTATION.success]: () => defaultState,
  [HIDE_FINISHED_CONSULTATION]: () => defaultState,
  [STOP_CONSULTATION_LOCAL]: () => defaultState,
  [LOGOUT.success]: () => defaultState,
  [LOGOUT.failure]: () => defaultState,
});
